/* eslint no-unused-vars: ['error', { 'varsIgnorePattern': 'slick' }] */
import slick from 'slick-carousel';

export default () => {

  if ($('.carousel-three-wide').length) {

    $('.carousel-three-wide-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button class="carousel-slides-nav-prev"><span class="sr-text">Previous</span></button>',
      nextArrow: '<button class="carousel-slides-nav-next"><span class="sr-text">Next</span></button>',
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // $('.carousel-slides-nav-prev').on('click', (e) => {
    //   e.preventDefault();
    // });

  }

};
